module.exports = __webpack_public_path__ + "img/6.48f4c73e.png";